export const BASE_URL = process.env.REACT_APP_CHANNEL_CONNECTOR_URL
export const SOCKET_URL = `${process.env.REACT_APP_BASE_SOCKET_URL}/chat`
export const POWERED_BY_URL =
  "https://orimon.ai/?utm_source=client_bot&utm_medium=chatbot&utm_campaign=powered_by_link"
//tenantId = 8800fb8c-8395-4e19-8ee9-65bad702f7e2 //testing purpose

export const PLATFORM = "web"

export const LCS_REQUEST_MESSAGE = "transfer to agent"
